
  $('.slide-image').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// klaviyo input field activated

document.addEventListener('click', function(event) {
    const teaser = event.target.closest(".kl-teaser-RQFVAU");
    if (teaser) {
      // console.log(teaser);
      let drawer = document.querySelector('#CartDrawer.js-drawer-open')
      if(drawer){
        console.log("drawer", drawer)
        drawer.querySelector(".js-drawer-close")?.click();
      }

      const NavDrawer = document.querySelector('#NavDrawer.js-drawer-open');
      if(NavDrawer){
         const navCon = NavDrawer.closest('[data-section-id="header"]')?.querySelector(".header-container");
        navCon.querySelector('button')?.click()
        console.log(NavDrawer) 
        console.log(navCon) 
      }
    }
});

// Run on load and on section reload

document.addEventListener("DOMContentLoaded", function () {
  const quickShopBtns = document.querySelectorAll('.quick-shop-trigger');
  const variantSelectionField = document.querySelectorAll('.quick-shop-container');
  const atcButtons = document.querySelectorAll('.new-add-to-cart-button');

  quickShopBtns.forEach((btn, index) => {
    btn.addEventListener('click', function () {
      console.log('Quick Shop clicked for index:', index);

      btn.classList.remove('show-Hv-varient');
      variantSelectionField[index].classList.add('show-Hv-varient');
      atcButtons[index].classList.add('show-Hv-varient');

      const variantBtns = variantSelectionField[index].querySelectorAll('.qs-variant-btn');

      // If there are variant buttons (multi-variant), bind logic
      if (variantBtns.length > 0) {
        variantBtns.forEach(buton => {
          buton.addEventListener('click', function () {
            const varId = buton.getAttribute('data-variant-id');
            console.log('Variant selected:', varId);

            const hiddenInput = variantSelectionField[index].querySelector('.selected-variant-id');
            if (hiddenInput) {
              hiddenInput.value = varId;
            }

            variantBtns.forEach(btn => btn.classList.remove('selected'));
            buton.classList.add('selected');

            atcButtons[index].setAttribute('data-variant-id', varId);
          });
        });

        // Auto-select first available variant (simulate click)
        const firstAvailableBtn = variantSelectionField[index].querySelector('.qs-variant-btn:not(.sold-out)');
        if (firstAvailableBtn) {
          firstAvailableBtn.click();
          console.log('Auto-selected first available variant.');
        }
      }

      // ✅ Else (only 1 variant): show Add to Cart button, but do NOT auto-submit.
      // Form will submit normally when Add to Cart is clicked.
    });
  });
});


document.querySelectorAll('.add-to-cart__form').forEach((form, index) => {
  form.addEventListener('submit', function(e) {
    e.preventDefault(); 
    const variantId = form.querySelector('.selected-variant-id').value;
    const addToCartBtn = form.querySelector('.new-add-to-cart-button');
    const quickShopBtn = form.querySelector('.quick-shop-trigger');
    const variantContainer = form.querySelector('.quick-shop-container');

    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => res.json())
    .then(data => {
     
      addToCartBtn.classList.remove('show-Hv-varient');
      quickShopBtn.classList.add('show-Hv-varient');
      variantContainer.classList.remove('show-Hv-varient');

      
      console.log(`Added variant ${variantId} to cart.`);
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
    });
  });
});

